"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_TYPES = void 0;
var BUTTON_TYPES = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  caution: 'caution'
});
exports.BUTTON_TYPES = BUTTON_TYPES;